import {
  row as iconRow,
  justifySpaceBetween as iconJustifyBetween,
  justifyLeft as iconJustifyLeft,
  justifyCenter as iconJustifyCenter,
  justifyRight as iconJustifyRight,
} from '@wordpress/icons';

if (typeof wp.data != 'undefined' && typeof wp.blocks != 'undefined') {

// Row Block

(function(wp) {
  var el = wp.element.createElement;
  let registerBlockType = wp.blocks.registerBlockType;
  var useBlockProps = wp.blockEditor.useBlockProps;
  var InnerBlocks = wp.blockEditor.InnerBlocks;

  registerBlockType('theme/row', {
    title: 'Row',
    category: 'design',
    icon: iconRow,
    edit: function(props) {
      // let blockProps = useBlockProps();

      // if (typeof props.className === 'undefined') {
      //   props.className = '';
      // }

      return el('div', props,
        el(InnerBlocks)
      )
    },
    save: function(attributes) {
      let blockProps = useBlockProps.save();

      return el('div', blockProps,
        el(InnerBlocks.Content)
      )
    }
  } );
})(window.wp);

// Row Controls

(function (wp) {
  var el = wp.element.createElement;
  var Fragment = wp.element.Fragment;
  var InspectorControls = wp.blockEditor.InspectorControls;
  var PanelBody = wp.components.PanelBody;
  var PanelRow = wp.components.PanelRow;

  var ToggleGroupControl = wp.components.__experimentalToggleGroupControl;
  var ToggleGroupControlOption = wp.components.__experimentalToggleGroupControlOption;
  var ToggleGroupControlOptionIcon = wp.components.__experimentalToggleGroupControlOptionIcon;

  var allowedBlocks = [
    'theme/row',
  ];

  function addAttributes(settings) {
    if (typeof settings.attributes !== 'undefined' && allowedBlocks.includes(settings.name)) {
      settings.attributes = Object.assign(settings.attributes, {
        themeAlign: {
          type: 'string',
          default: 'start'
        },
        themeJustify: {
          type: 'string',
          default: 'between'
        },
        themeMargin: {
          type: 'string',
          default: 'none'
        },
      });
    }

    return settings;
  }

  var withInspectorControls = wp.compose.createHigherOrderComponent(function(BlockEdit) {
    return function(props) {
      if (!props.isSelected || !allowedBlocks.includes(props.name)) {
        return el(Fragment, {},
          el(BlockEdit, props)
        );
      }

      controls = el(InspectorControls, {},
        el(PanelBody, {
          title: 'Layout',
          initialOpen: true
        },
          el(PanelRow, {},
            el(ToggleGroupControl, {
              label: 'Align',
              className: 'toggle_group toggle_group_align',
              value: props.attributes.themeAlign,
              onChange: (val) => props.setAttributes({ themeAlign: val }),
            },
              el(ToggleGroupControlOptionIcon, {
                label: 'Start',
                value: 'start',
                icon: iconJustifyLeft,
                size: 32,
              }, el(iconJustifyLeft)),
              el(ToggleGroupControlOptionIcon, {
                label: 'Center',
                value: 'center',
                icon: iconJustifyCenter,
              }),
              el(ToggleGroupControlOptionIcon, {
                label: 'End',
                value: 'end',
                icon: iconJustifyRight,
              }),
            ), // toggle group
          ),
          el(PanelRow, {},
            el(ToggleGroupControl, {
              label: 'Justify', // - Desktop',
              className: 'toggle_group toggle_group_justify',
              value: props.attributes.themeJustify,
              onChange: (val) => props.setAttributes({ themeJustify: val }),
            },
              el(ToggleGroupControlOptionIcon, {
                label: 'Between',
                value: 'between',
                icon: iconJustifyBetween,
                size: 32,
              }),
              el(ToggleGroupControlOptionIcon, {
                label: 'Start',
                value: 'start',
                icon: iconJustifyLeft,
                size: 32,
              }, el(iconJustifyLeft)),
              el(ToggleGroupControlOptionIcon, {
                label: 'Center',
                value: 'center',
                icon: iconJustifyCenter,
              }),
              el(ToggleGroupControlOptionIcon, {
                label: 'End',
                value: 'end',
                icon: iconJustifyRight,
              }),
            ), // toggle group
          ),
          el(PanelRow, {},
            el(ToggleGroupControl, {
              label: 'Margin',
              className: 'toggle_group',
              value: props.attributes.themeMargin,
              onChange: (val) => props.setAttributes({ themeMargin: val }),
            },
              el(ToggleGroupControlOption, {
                label: 'None',
                value: 'none',
              }),
              el(ToggleGroupControlOption, {
                label: 'Small',
                value: 'small',
              }),
              el(ToggleGroupControlOption, {
                label: 'Large',
                value: 'large',
              }),
            ), // toggle group
          ),
        ),
      );

      return el(Fragment, {},
        el(BlockEdit, props),
        controls,
      );
    };
  }, 'withInspectorControls');

  var withCustomClassName = wp.compose.createHigherOrderComponent(function(BlockListBlock) {
    return function(props) {
      if (allowedBlocks.includes(props.name)) {
        if (typeof props.className === 'undefined') {
          props.className = '';
        }

        props.className = props.className.replace(/row-align-start/g, '');
        props.className = props.className.replace(/row-align-center/g, '');
        props.className = props.className.replace(/row-align-end/g, '');

        if (typeof props.attributes.themeAlign !== 'undefined') {
          let className = 'row-align-' + props.attributes.themeAlign;
          props.className += ' ' + className;
        }

        props.className = props.className.replace(/row-justify-start/g, '');
        props.className = props.className.replace(/row-justify-center/g, '');
        props.className = props.className.replace(/row-justify-end/g, '');

        if (typeof props.attributes.themeJustify !== 'undefined') {
          let className = 'row-justify-' + props.attributes.themeJustify;
          props.className += ' ' + className;
        }

        props.className = props.className.replace(/margin_none/g, '');
        props.className = props.className.replace(/margin_small/g, '');
        props.className = props.className.replace(/margin_large/g, '');

        if (typeof props.attributes.themeMargin !== 'undefined') {
          let className = 'margin_' + props.attributes.themeMargin;
          props.className += ' ' + className;
        }
      }

      return el(BlockListBlock, props);
    };
  }, 'withInspectorControls');

  function applyExtraClass(extraProps, blockType, attributes) {
    if (allowedBlocks.includes(blockType.name)) {
      if (typeof extraProps.className === 'undefined') {
        extraProps.className = '';
      }

      extraProps.className = extraProps.className.replace(/row-align-start/g, '');
      extraProps.className = extraProps.className.replace(/row-align-center/g, '');
      extraProps.className = extraProps.className.replace(/row-align-end/g, '');

      if (typeof attributes.themeAlign !== 'undefined') {
        let className = 'row-align-' + attributes.themeAlign;
        extraProps.className += ' ' + className;
      }

      extraProps.className = extraProps.className.replace(/row-justify-between/g, '');
      extraProps.className = extraProps.className.replace(/row-justify-start/g, '');
      extraProps.className = extraProps.className.replace(/row-justify-center/g, '');
      extraProps.className = extraProps.className.replace(/row-justify-end/g, '');

      if (typeof attributes.themeJustify !== 'undefined') {
        let className = 'row-justify-' + attributes.themeJustify;
        extraProps.className += ' ' + className;
      }

      extraProps.className = extraProps.className.replace(/margin_none/g, '');
      extraProps.className = extraProps.className.replace(/margin_small/g, '');
      extraProps.className = extraProps.className.replace(/margin_large/g, '');

      if (typeof attributes.themeMargin !== 'undefined') {
        let className = ' margin_' + attributes.themeMargin;
        extraProps.className += ' ' + className;
      }
    }

    return extraProps;
  }

  wp.hooks.addFilter(
    'blocks.registerBlockType',
    'theme/theme-row-attributes',
    addAttributes
  );

  wp.hooks.addFilter(
    'editor.BlockEdit',
    'theme/theme-row-controls',
    withInspectorControls
  );

  wp.hooks.addFilter(
    'editor.BlockListBlock',
    'theme/theme-row-class-admin',
    withCustomClassName
  );

  wp.hooks.addFilter(
    'blocks.getSaveContent.extraProps',
    'theme/theme-row-class',
    applyExtraClass
  );
})(window.wp);

}
